
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/eesii",
      function () {
        return require("private-next-pages/destinations/eesii.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/eesii"])
      });
    }
  